// import { Fade } from "react-awesome-reveal";
import { BellIcon, LockIcon, StarIcon } from "utils/Icons";

const TimeLine = () => {
  // timeline data
  let timeLineData = [
    {
      title: `Today`,
      desc: `Get instant access and see how it can change your life.`,
      icon: <LockIcon />,
    },
    {
      title: `Day 5`,
      desc: `We’ll remind you with an email or notification that your trial is
    ending.`,
      icon: <BellIcon />,
    },
    {
      title: `Day 7`,
      desc: `You’ll be charged for your membership.`,
      icon: <StarIcon />,
    },
  ];
  return (
    <div className="timeline_wrapper d_flex flex_col">
      {/* <Fade
        
        direction="up"
        triggerOnce
        delay={750 + (index + 100)}
        duration={1400}
      > */}
      {timeLineData?.map((item, index) => (
          <div key={index} className="timeline_box d_flex">
            <div className="timeline_icon">{item?.icon}</div>
            <div className="timeline_content">
              <h5>{item?.title}</h5>
              <p>{item?.desc}</p>
            </div>
          </div>
      ))}
      {/* </Fade> */}
    </div>
  );
};

export default TimeLine;
